import React from 'react';

import { Text } from '@reckon-web/text';

import { ActivityTargetValue } from '../activities-types';
import { getTargetType } from '../helper';

interface IActivityCategoryCreated {
  activityTarget: ActivityTargetValue;
}
// ActivityCategory Created = 1
export const ActivityCategoryCreated = ({
  activityTarget,
}: IActivityCategoryCreated) => (
  <Text size="small">Created the {getTargetType(activityTarget)}</Text>
);
